import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Draggable } from 'react-beautiful-dnd';
import { Icon } from '@vectord/components';

import DeleteLibraryClass from '../DeleteLibraryClass';
import {
  LECTURE_TYPES,
  parseAcademyTopicClassType,
} from 'features/classCreation';
import styles from './LibraryClassRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

function LibraryClassRow({ cls, index }) {
  const classType = parseAcademyTopicClassType(cls.academy_topic);

  return (
    <Draggable
      draggableId={String(cls.id)}
      index={index}
    >
      {({ draggableProps, dragHandleProps, innerRef }, { isDragging }) => (
        <TableRow
          ref={innerRef}
          className={classNames({
            [styles.rowDragActive]: isDragging,
          })}
          {...draggableProps}
        >
          <TableCell className={styles.classTitle}>
            <Link
              className="link"
              to={`/classes/edit-classes/${cls.academy_topic.id}`}
              target="_blank"
            >
              {cls.academy_topic.title}
            </Link>
          </TableCell>
          <TableCell className={styles.classType}>
            {classType} (
            {cls.academy_topic.bucket_id
              ? LECTURE_TYPES.optional
              : LECTURE_TYPES.regular}
            )
          </TableCell>
          <TableCell className="text-c">
            {cls.academy_topic.junction_number || '-'}
          </TableCell>
          <TableCell className={styles.deleteAction}>
            <DeleteLibraryClass cls={cls} />
          </TableCell>
          <TableCell className={styles.reorderAction}>
            <Icon
              name="hamburger"
              {...dragHandleProps}
            />
          </TableCell>
        </TableRow>
      )}
    </Draggable>
  );
}

export default LibraryClassRow;
